<template>
  <div class="common-card">
    <modal-filter
      :filter_invoice_id.sync="filter_invoice_id"
      :filter_user_id.sync="filter_user_id"
      :filter_salary_type.sync="filter_salary_type"
      :filter_expense_status_id.sync="filter_expense_status_id"
      :filter_start_date.sync="filter_start_date"
      :filter_end_date.sync="filter_end_date"
      :filter_min_amount.sync="filter_min_amount"
      :filter_max_amount.sync="filter_max_amount"
      :invoiceOptions="invoiceOptions"
      :userOptions="userOptions"
      :expenseStatusOptions="expenseStatusOptions"
      @refetch-data="refetchData"
    />
    <modal-status
      :expense-data="expenseData"
      :expenseStatusOptions="expenseStatusOptions"
      @refetch-data="refetchData"
    />
    <modal-approval
      :approve-data="approveData"
      @refetch-data="refetchData"
    />

    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon
              class="mr-50"
              icon="fa-solid fa-money-check-dollar"
            />
            薪金支出記錄
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
            <b-form-input
              v-model="searchQuery"
              class="search-form mb-1 mb-sm-0 ml-sm-1"
              placeholder="搜尋記錄"
            />
          </div>
        </div>
          <div class="d-flex flex-wrap mobile-w100 mt-1 mt-lg-0">

            <b-button
              variant="primary"
              class="mobile-w100 mb-1 mb-sm-0 mr-sm-1"
              @click="$bvModal.show('modal-filter')"
              ><feather-icon
                class="mr-1"
                icon="filterIcon"
                size="18"
              ></feather-icon
              >篩選</b-button
            >
            <!-- 匯出功能按鈕 -->
            <b-dropdown
              v-if="ability.can('export', 'expenditures')"
              variant="success"
              text="匯出"
              class="mobile-w100 mb-1 mb-sm-0 mr-sm-1"
              :disabled="isExporting"
            >
              <template #button-content>
                <b-spinner
                  v-if="isExporting"
                  small
                  class="mr-1"
                ></b-spinner>
                <feather-icon
                  v-else
                  size="16"
                  class="mr-1"
                  icon="DownloadIcon"
                />
                {{ isExporting ? '匯出中...' : '匯出' }}
              </template>
              <b-dropdown-item
                @click="exportCurrentPage"
                :disabled="isExporting"
              >
                <feather-icon size="16" class="mr-1" icon="FileTextIcon" />
                匯出此頁面
              </b-dropdown-item>
              <b-dropdown-item
                @click="exportAllRecords"
                :disabled="isExporting"
              >
                <feather-icon size="16" class="mr-1" icon="DatabaseIcon" />
                匯出全部記錄
              </b-dropdown-item>
            </b-dropdown>
            <b-button class="mobile-w100" :to="{ name: 'expenditure-create' }" v-if="ability.can('create', 'expenditures')">
              <feather-icon
                class="mr-1"
                icon="plusIcon"
                size="18"
              ></feather-icon
              >新增記錄</b-button
            >
          </div>
      </div>
    </b-card>
    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refExpenditureListTable"
          class="position-relative"
          :items="fetchExpenditures"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- <template #cell(id)="data">
              {{ data.item.expense_number}}
          </template> -->

          <template #cell(is_approved)="data">
            <feather-icon
              v-if="data.item.is_approved"
              icon="CheckIcon"
              size="18"
              class="mr-50 text-success"
            />
          </template>

          <template #cell(salary_type)="data">
            {{ getSalaryType(data.item.salary_type).name }}
          </template>



          <template #cell(address)="data">
            {{ getProjectAddress(data.item.project_id) }}
          </template>

            <template #cell(year_month)="data">
              {{ data.item.salary_year? data.item.salary_year + '年 ' : '' }}{{ data.item.salary_month ? data.item.salary_month + '月' : '' }}
            </template>

            <template #cell(salary_receive_method_id)="data">
              {{ getSalaryReceiveMethod(data.item.salary_receive_method_id).name  }}
            </template>

          <template #cell(actual_salary)="data">
              <div v-if="data.item.salary_records && data.item.salary_records.length > 0">
                ${{data.item.salary_records.reduce((sum, record) => sum + getActualSalary(record), 0 )}}
              </div>
          </template>
          
          <template #cell(expense_date)="data">
            {{ getDateTime(data.item.expense_date, true) }}
          </template>

          <template #cell(total_amount)="data">
            <div>
              ${{ data.item.total_amount}}
            </div>
          </template>

          <template #cell(expense_status)="data">
            <a
              v-if="ability.can('status', 'expenditures')"
              href="javascript:void(0)"
              @click="handleStatus(data.item)"
              class="d-flex align-items-center"
            >
              <feather-icon   :class="`mr-25 ${isUnpaidStatus(data.item.expense_status) ? 'text-danger' : ''}`" icon="EditIcon" />
              <span
                :class="{
                  'text-danger': isUnpaidStatus(data.item.expense_status)
                }"
              >
                {{ data.item.expense_status && data.item.expense_status.name }}
              </span>
            </a>
            <div
              v-else
              :class="{
                'text-danger': isUnpaidStatus(data.item.expense_status)
              }"
            >
              {{ data.item.expense_status ? data.item.expense_status.name : '- -' }}
            </div>
          </template>

          <!-- Column: salary_records -->
          <template #cell(show_details)="row">
            <b-button
              v-if="row.item.salary_records && row.item.salary_records.length > 0"
              size="sm"
              @click="row.toggleDetails()"
              class="mr-2"
            >
              {{ row.detailsShowing ? "隱藏" : "顯示" }}
            </b-button>
            <span v-else>- -</span>
          </template>

          <template #row-details="row">
            <div class="info-container" v-if="row.item.salary_records">
                <b-col cols="12" class="px-0">
                  <label>PS. 實發工資 = 各項工資 + 各項佣金/花紅 +
              各項其他津貼 + 各項逾時工作金額 - 各項強積金(僱員)</label>
                </b-col>                
                <b-col cols="12" class="px-0">
                  <label>PS. 公司總支出金額 = 各項工資 + 各項佣金/花紅 +
              各項其他津貼 + 各項逾時工作金額 + 各項強積金(僱主)</label>
                </b-col>
              <b-row
                class="p-2 backgroundColor5 my-1"
                v-for="(worker, index) in row.item.salary_records"
                :key="`cost${index}`"
              >
                <b-col cols="12" md="4">
                  <div class="row mb-50">
                    <b class="label" v-if="getUserById(worker.user_id).user_type_id === 1">員工：</b>
                    <b class="label" v-if="getUserById(worker.user_id).user_type_id === 4">師傅：</b>
                    <span>  {{
                      getUserById(worker.user_id).position ? `[${getUserById(worker.user_id).position}]` : '' }} {{
                      getUserById(worker.user_id).name_cn
                    }}</span>
                  </div>
                  <!-- <div class="row mb-50">
                    <b class="label">職位：</b>
                    <span>{{ 
                      getUserById(worker.user_id).position }}</span>
                  </div> -->
                  <!-- 根據 payment_method_id 顯示不同的工資計算方式 -->
                  <!-- 日薪 (payment_method_id = 1 或 salary_type = 1) -->
                  <div class="row mb-50" v-if="getSalaryDisplayType(worker) === 'daily'">
                    <b class="label">工資：</b>
                    <span>{{ worker.working_days }}天 × ${{ worker.day_salary }}每日 = ${{ worker.total_salary || 0.00 }}</span>
                  </div>

                  <!-- 月薪 (payment_method_id = 2 或 salary_type = 2) -->
                  <!-- <div class="row mb-50" v-if="getSalaryDisplayType(worker) === 'monthly'">
                    <b class="label">出糧月份：</b>
                    <span>{{ worker.salary_year }}年 {{ worker.salary_month }}月</span>
                  </div> -->
                  <div class="row mb-50" v-if="getSalaryDisplayType(worker) === 'monthly'">
                    <b class="label">月薪：</b>
                    <span>${{ worker.total_salary || 0.00 }}</span>
                  </div>

                  <!-- 項目計算 (payment_method_id = 3 或 salary_type = 3) -->
                  <div class="row mb-50" v-if="getSalaryDisplayType(worker) === 'project'">
                    <b class="label">工程工資：</b>
                    <span>${{ worker.total_salary || 0.00 }}</span>
                  </div>
                  <div class="row mb-50" >
                    <b class="label">逾時工作：</b>
                    <span v-if="worker.ot_amount">{{ worker.ot_hours || 0.00 }}小時 = 金額${{ worker.ot_amount || 0.00 }}</span>
                    <span v-else>--</span>
                  </div>
                  <div class="row mb-50" >
                    <b class="label">佣金/花紅：</b>
                    <span>${{ worker.commission || 0.00 }}</span>
                  </div>
                  <div class="row mb-50" >
                    <b class="label">其他津貼：</b>
                    <span>${{ worker.allowance || 0.00 }} {{ worker.allowance_remark ? ` - ${worker.allowance_remark}` : '' }}</span>
                  </div>
                  <div class="row mb-50" >
                    <b class="label">強積金：</b>
                    <span><b>強積金(僱主)：</b>${{ worker.mpf_employer || 0.00 }} <b>強積金(僱員)：</b>${{ worker.mpf_employee || 0.00 }}</span>
                  </div>

                  <div class="row mb-50">
                    <b class="label">實發工資：</b>
                    <span>${{getActualSalary(worker) }}</span>
                  </div>

                </b-col>
                <b-col cols="12" md="4">
                  <!-- <div class="row mb-50">
                    <b class="label">收款方式：</b>
                    <span>{{ getSalaryReceiveMethod(worker.salary_receive_method_id).name }}</span>
                  </div>
                  <div class="row mb-50" v-if="worker.salary_receive_method_id == 1">
                    <b class="label">支票號碼：</b>
                    <span>{{ worker.check_number }}</span>
                  </div> -->
                  <!-- <div class="row mb-50" v-if="getSalaryDisplayType(worker) === 'daily'">
                    <b class="label">開工日期：</b>
                    <span>{{ formatWorkingDate(worker.working_date) }}</span>
                  </div>
                  <div class="row mb-50" v-if="getSalaryDisplayType(worker) === 'project'">
                    <b class="label">工作週期：</b>
                    <pre>{{ worker.working_date || '--' }}</pre>
                  </div> -->
                  <div class="row mb-50" v-if="worker.invoice_id ">
                    <b class="label">發票：</b>
                    <span >{{ getInvoiceInfo(worker.invoice_id) }}</span>
                  </div>
                  <div class="row mb-50" >
                    <b class="label">備註：</b>
                    <pre>{{ worker.remark || '--' }}</pre>
                  </div>
                </b-col>
              </b-row>

              <!-- 日薪匯總卡片 -->
              <div
                v-if="row.item.salary_type === 1 && getDailySalarySummary(row.item.salary_records)"
                class="mb-1"
              >
                <b-card
                  class="salary-summary-card"
                  style="background-color: #f0ffc2; margin-left: -1rem;"
                >
                    <h6 class="mb-1 font-weight-bold">
                      工資匯總
                    </h6>

                  <b-row>
                    <b-col cols="12" md="3">
                      <div class="summary-item mb-2">
                        <span class="summary-label">總逾時工作金額：</span>
                        <span class="summary-value font-weight-bold">
                          {{ formatCurrency(getDailySalarySummary(row.item.salary_records).totalOtAmount) }}
                        </span>
                      </div>
                      <div class="summary-item mb-2">
                        <span class="summary-label">總佣金/花紅：</span>
                        <span class="summary-value font-weight-bold">
                          {{ formatCurrency(getDailySalarySummary(row.item.salary_records).totalCommission) }}
                        </span>
                      </div>
                      <div class="summary-item mb-2">
                        <span class="summary-label">總其他津貼：</span>
                        <span class="summary-value font-weight-bold">
                          {{ formatCurrency(getDailySalarySummary(row.item.salary_records).totalAllowance) }}
                        </span>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3">
                      <div class="summary-item mb-2">
                        <span class="summary-label">總僱主強積金：</span>
                        <span class="summary-value font-weight-bold">
                          {{ formatCurrency(getDailySalarySummary(row.item.salary_records).totalMpfEmployer) }}
                        </span>
                      </div>
                      <div class="summary-item mb-2">
                        <span class="summary-label">總僱員強積金：</span>
                        <span class="summary-value font-weight-bold">
                          {{ formatCurrency(getDailySalarySummary(row.item.salary_records).totalMpfEmployee) }}
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                  <hr/>
                      <div class="summary-item">
                        <span class="summary-label">總工資金額：</span>
                        <span class="summary-value font-weight-bold text-primary">
                          {{ formatCurrency(getDailySalarySummary(row.item.salary_records).totalSalary) }}
                        </span>
                      </div>
                </b-card>
              </div>

            </div>
          </template>

          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                expendituresList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
          
              <b-dropdown-item
                v-if="ability.can('update', 'expenditures')"
                :to="{
                  name: 'expenditure-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('status', 'expenditures')"
                @click="handleStatus(data.item)"
              >
                <feather-icon icon="CheckIcon" />
                <span class="align-middle ml-50">更改薪金支出狀態</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'expenditures')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>

            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import useExpendituresList from "./useExpendituresList";
import expenditureStoreModule from "../expenditureStoreModule";
import ModalFilter from "../modal/ModalFilter";
import ModalApproval from "../modal/ModalApproval";
import ModalStatus from "../modal/ModalStatus";
import { formatWorkingDate } from "@/utils/dateFormatter";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    vSelect,
    ModalFilter,
    ModalApproval,
    ModalStatus
  },
  data() {
    return {
      approveData: null,
      expenseData: null,
      isExporting: false,
    };
  },
  methods: {
    getActualSalary(item){
      return Number(item.total_salary || 0.00) + Number(item.commission || 0.00) + Number(item.allowance || 0.00) + Number(item.ot_amount || 0.00) - Number(item.mpf_employee || 0.00)
    },
    // 計算公司實際支出（不包含僱員強積金）
    getCompanyExpense(item) {
      return Number(item.total_salary || 0.00) + Number(item.commission || 0.00) + Number(item.allowance || 0.00) + Number(item.ot_amount || 0.00) + Number(item.mpf_employer || 0.00)
    },
    // 計算日薪匯總數據
    getDailySalarySummary(salaryRecords) {
      if (!salaryRecords || salaryRecords.length <= 1) {
        return null;
      }

      return {
        totalOtAmount: salaryRecords.reduce((sum, record) => sum + (Number(record.ot_amount) || 0), 0),
        totalCommission: salaryRecords.reduce((sum, record) => sum + (Number(record.commission) || 0), 0),
        totalAllowance: salaryRecords.reduce((sum, record) => sum + (Number(record.allowance) || 0), 0),
        totalMpfEmployer: salaryRecords.reduce((sum, record) => sum + (Number(record.mpf_employer) || 0), 0),
        totalMpfEmployee: salaryRecords.reduce((sum, record) => sum + (Number(record.mpf_employee) || 0), 0),
        totalSalary: salaryRecords.reduce((sum, record) => sum + (Number(record.total_salary) || 0), 0)
      };
    },
    // 格式化金額為 HK$ 格式
    formatCurrency(amount) {
      return `HK$${Number(amount || 0).toFixed(2)}`;
    },
    getSalaryType(salaryType) {
      if (!salaryType || !this.salaryTypeOptions?.length) return { name: '- -' };
      return this.salaryTypeOptions.find(s => s.id === salaryType) || { name: '- -' };
    },
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("expenditure/deleteExpenditure", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    handleStatus(item) {
      this.expenseData = item;
      this.$bvModal.show("modal-status");
    },
    handleApproval(item) {
      this.approveData = item;
      this.$bvModal.show("modal-approval");
    },
    // 判斷是否為未支付狀態 - 用於條件式樣式顯示
    // 當狀態為「開支未支付」(ID: 3) 時，文字顯示為紅色
    isUnpaidStatus(expenseStatus) {
      if (!expenseStatus) return false;
      return expenseStatus.id === 3 || expenseStatus.name === '開支未支付';
    },
    getProjectById(projectId) {
      if (!projectId || !this.projectOptions || !this.projectOptions.length) return null;
      return this.projectOptions.find(p => p.id === projectId) || null;
    },

    getUserById(userId) {
      if (!userId || !this.userOptions?.length) return null;
      return this.userOptions.find(u => u.id === userId) || null;
    },

    getWorkerById(workerId) {
      if (!workerId || !this.workerOptions?.length) return null;
      return this.workerOptions.find(w => w.id === workerId) || null;
    },
    getInvoiceInfo(invoiceId) {
      if (!invoiceId || !this.invoiceOptions?.length) return null;
      const invoice = this.invoiceOptions.find(i => i.id === invoiceId);
      return invoice ? `[${invoice.invoice_number}] ${invoice.name_cn} ${invoice.address}` : null;
    },

    getSalaryDisplayType(worker) {
      // 根據員工的 payment_method_id 或 salary_type 決定顯示方式
      const user = this.getUserById(worker.user_id);
      const paymentMethodId = user?.payment_method_id || worker.salary_type;

      if (paymentMethodId === 1) {
        return 'daily'; // 日薪
      } else if (paymentMethodId === 2) {
        return 'monthly'; // 月薪
      } else if (paymentMethodId === 3) {
        return 'project'; // 項目計算
      } else {
        // 預設根據 is_monthly 判斷
        return worker.is_monthly === 1 ? 'monthly' : 'daily';
      }
    },

    getProjectNumber(projectId) {
      const project = this.getProjectById(projectId);
      return project ? project.project_number : '- -';
    },

    getProjectName(projectId) {
      const project = this.getProjectById(projectId);
      return project ? project.project_name : '- -';
    },

    getProjectAddress(projectId) {
      const project = this.getProjectById(projectId);
      return project ? project.address : '- -';
    },

    formatWorkingDate,

    // 匯出此頁面
    exportCurrentPage() {
      if (this.isExporting) return;

      this.isExporting = true;
      this.exportRecords('current')
        .then(exportData => {
          this.downloadExcel(exportData, '薪金支出記錄_當前頁面');
        })
        .catch(error => {
          console.error('匯出當前頁面失敗:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "匯出失敗",
              text: "匯出當前頁面失敗，請稍後再試",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.isExporting = false;
        });
    },

    // 匯出全部記錄
    exportAllRecords() {
      if (this.isExporting) return;

      this.isExporting = true;
      this.exportRecords('all')
        .then(exportData => {
          this.downloadExcel(exportData, '薪金支出記錄_全部記錄');
        })
        .catch(error => {
          console.error('匯出全部記錄失敗:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "匯出失敗",
              text: "匯出全部記錄失敗，請稍後再試",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.isExporting = false;
        });
    },

    // 下載 Excel 文件
    downloadExcel(data, filename) {
      if (!data || data.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "匯出失敗",
            text: "沒有數據可以匯出",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      // 計算實際記錄數量
      const actualRecordCount = data.length;

      // 匯出為 Excel (使用 ExcelJS 支援完整樣式)
      import("@/utils/excelExport").then(async (excelExport) => {
        try {
          // 使用專業級的薪金支出記錄匯出函數
          const success = await excelExport.export_expenditures_to_excel_styled({
            title: '薪金支出記錄',
            data: data,
            filename: filename,
            bookType: 'xlsx'
          });

          if (success) {
            // 顯示成功訊息
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "匯出成功",
                text: `已成功匯出 ${actualRecordCount} 筆記錄，檔案包含完整的格式化樣式`,
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
          } else {
            throw new Error('匯出過程中發生錯誤');
          }
        } catch (error) {
          console.error('Excel 匯出失敗:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "匯出失敗",
              text: "Excel 匯出過程中發生錯誤，請稍後再試",
              icon: "XCircleIcon",
              variant: "danger",
            },
          });
        }
      }).catch((error) => {
        console.error('匯出失敗:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "匯出失敗",
            text: "Excel 匯出功能載入失敗",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "expenditure";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, expenditureStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });



    const getApprove = (id) => {
      if (id) {
        const obj =
          expenseStatusOptions.value &&
          expenseStatusOptions.value.length > 0 &&
          expenseStatusOptions.value.find((ele) => ele.id == id);
        return { ...obj };
      } else {
        return "- -";
      }
    };

    const getSalaryReceiveMethod = (id) => {
      if (!id || !salaryReceiveMethodOptions.value?.length) return { name: '- -' };
      return salaryReceiveMethodOptions.value.find(s => s.id === id) || { name: '- -' };
    };

    const salaryTypeOptions = [
      { id: 1, name: '日薪' },
      { id: 2, name: '月薪' },
      { id: 3, name: '以工程項目計算' },
    ]

    const {
      fetchExpenditures,
      tableColumns,
      perPage,
      totalRow,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      dataMeta,
      expendituresList,
      refExpenditureListTable,
      ability,
      refetchData,
      filter_invoice_id,
      filter_user_id,
      filter_salary_type,
      filter_expense_status_id,
      filter_start_date,
      filter_end_date,
      filter_min_amount,
      filter_max_amount,
      invoiceOptions,
      workerOptions,
      expenseStatusOptions,
      salaryReceiveMethodOptions,
      userOptions,
      productOptions,
      exportRecords,
    } = useExpendituresList();

    return {
      fetchExpenditures,
      tableColumns,
      perPage,
      totalRow,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      dataMeta,
      expendituresList,
      refExpenditureListTable,
      ability,
      refetchData,
      filter_invoice_id,
      filter_user_id,
      filter_salary_type,
      filter_expense_status_id,
      filter_start_date,
      filter_end_date,
      filter_min_amount,
      filter_max_amount,
      invoiceOptions,
      workerOptions,
      expenseStatusOptions,
      salaryReceiveMethodOptions,
      userOptions,
      productOptions,
      getApprove,
      getSalaryReceiveMethod,
      salaryTypeOptions,
      exportRecords,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.salary-summary-card {
  border: 1px solid #d4e6b7;
  border-radius: 8px;

  .summary-item {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    padding: 4px 0;

    .summary-label {
      color: #495057;
      font-size: 0.9rem;
    }

    .summary-value {
      color: #28a745;
      font-size: 0.95rem;

      &.text-primary {
        color: #007bff !important;
        font-size: 1rem;
      }
    }
  }
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
    